import _extends from "@babel/runtime/helpers/extends";
export default withDraggableOrder;
import { addExtraInfoComponents } from './infoUtils';
function mapOrderFromControllerDataAndOrderlist(list, controller) {
  const sections = controller.options.filter(i => i.type === 'section');
  const result = sections.reduce((acc, curr) => {
    return _extends({}, acc, {
      [curr.key]: []
    });
  }, {});
  let currentSection = sections[0];
  const splited = list.split(',');
  // for (let i = 0; i <splited.length; i++) {
  for (const item of splited) {
    const currentSectionIndex = sections.findIndex(x => x.key === item);
    if (currentSectionIndex !== -1) {
      currentSection = sections[currentSectionIndex];
      continue;
    } else {
      result[currentSection.key].push(item);
    }
  }
  return result;
}
function withDraggableOrder(controller, mapper) {
  return value => {
    const valueWithAdditionalItems = addExtraInfoComponents(value, controller);
    const order = mapOrderFromControllerDataAndOrderlist(valueWithAdditionalItems, controller);
    return mapper(order);
  };
}
//# sourceMappingURL=withDraggableOrder.js.map